import type { CheckinBlocker, CheckinBlockerUser } from 'src/shared/CheckinBlocker/_types';

function blockerDedupeKey(blocker: CheckinBlocker): string {
  return `${blocker.type}:${blocker.title ?? ''}:${blocker.message ?? ''}`;
}

/**
 * Merges duplicate `CheckinBlockerUser` entries that share the same `id` (e.g. the same
 * client with multiple selected visits) and de-duplicates identical blockers per user.
 */
export function mergeCheckinBlockerUsers(
  users: CheckinBlockerUser[]
): CheckinBlockerUser[] {
  const byId = new Map<string, CheckinBlockerUser>();

  for (const user of users) {
    const existing = byId.get(user.id);
    if (!existing) {
      byId.set(user.id, { ...user, blockers: [...user.blockers] });
      continue;
    }

    const seen = new Set(existing.blockers.map(blockerDedupeKey));
    for (const blocker of user.blockers) {
      const key = blockerDedupeKey(blocker);
      if (!seen.has(key)) {
        seen.add(key);
        existing.blockers.push(blocker);
      }
    }
  }

  return Array.from(byId.values());
}
